<template>
    <div v-if="atp && atp.laudo && atp.laudo.arquivos && atp.laudo.arquivos.length" class="mb-3">
        <div class="d-flex flex-column mb-1" v-for="(arq, iax) in lista_arq" :key="iax">
            <a v-if="arq.st_tipo_especial != 'audio'" :href="arq.arquivo.temporary_url" class="btn btn-sm" :class="arq.st_tipo_especial == 'anexo' ? 'btn-outline-secondary' : 'btn-outline-primary'" target="_blank">
                <template v-if="arq.st_tipo_especial == 'anexo'">
                    <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>    
                    Anexo
                </template>
                <template v-else>
                    <i class="fa fa-print mr-2" aria-hidden="true"></i>
                    Visualizar Laudo
                </template>
                <span class="badge ml-5" :class="arq.st_tipo_especial == 'anexo' ? 'badge-secondary' : 'badge-primary'">
                    <i class="fa-solid fa-key mr-2" v-if="arq.fl_key"></i>
                    {{ arq.arquivo.st_titulo }}
                </span>
            </a>
            <div class="btn btn-lg d-flex justify-content-center align-items-center" :class="iax === audio_selecionado ? 'btn-primary' : 'btn-outline-primary'" @click="selec_audio(iax)" v-else>
                {{ arq.arquivo.st_titulo }}
                <audio 
                    :ref="'audio' + iax"
                    class="ml-2 w-50"
                    :src="arq.arquivo.temporary_url"
                    style="height: 30px;"
                    controls
                    controlsList="nodownload"
                ></audio>
            </div>

            <audio-player :src="arq.arquivo.temporary_url" v-if="false && arq.st_tipo_especial == 'audio'" />
        </div>

        <div v-if="audio_selec" class="text-center small text-muted">
            <span><strong>Ctrl + Espaço</strong> para play/pause</span>
            <span class="mx-5"><strong>Ctrl + &lt;</strong> para -3s</span> 
            <span><strong>Ctrl + &gt;</strong> para +3s.</span>
        </div>

        <div v-else class="form-row mb-1">
            <div class="col col-12 col-md-4">
                <template v-if="tem_imagens_chave">
                    <input type="checkbox" v-model="atp.laudo.fl_imp_keys" class="mr-1" :disabled="pode_alterar !== true">
                    <span class="small">
                        Apenas imagens chave no laudo
                    </span>
                </template>
            </div>
            <div class="col col-12 col-md-4 text-center">
                <a href="#" class="card-link small" @click="top3 = !top3" v-if="atp.laudo.arquivos.length > 3">
                    {{ top3 ? 'Ver mais...' : 'Ver menos...' }} ({{ atp.laudo.arquivos.length - 3 }})
                </a>
            </div>
            <div class="col col-12 col-md-4 text-right">
                
                <button type="button" class="btn btn-outline-primary btn-sm ml-1" @click="ver_conteudo()">
                    <i class="fa-regular fa-images"></i>
                </button>
                <button type="button" class="btn btn-outline-primary btn-sm ml-1" @click="ver_conteudo(true)">
                    <i class="fa-solid fa-right-to-line"></i>
                </button>
            </div>
        </div>

        <pre v-if="false">pode_alterar: {{ pode_alterar }}</pre>

        <view-anexos-preview 
            ref="preview" 
            :viewonly="!pode_alterar"
            @refresh_item="refresh_item" 
            @remover_item="remover_item" /> 
    </div>
</template>

<script>
import _ from 'lodash';
import AudioPlayer from './AudioPlayer.vue';
import ViewAnexosPreview from '../../shared/gallery/ViewAnexosPreview.vue';

export default {
    data() { 
        return { 
            audio_selecionado: null, 
            lastSilence: null, 
            top3: true, 
        }
    },

    props: ['atp', 'pode_alterar'], 

    components: {
        AudioPlayer,
        ViewAnexosPreview,
    },

    computed: { 
        lista_arq: function () { 
            if ( this.atp && this.atp.laudo && this.atp.laudo.arquivos ) { 
                if ( this.top3 && ( this.atp.laudo.arquivos.length > 3 ) ) { 
                    return _.take(this.atp.laudo.arquivos, 3);
                } else { 
                    return this.atp.laudo.arquivos;
                }
            }
        },

        audio_selec: function() {
            if (this.audio_selecionado === null) return null;

            if ( this.$refs['audio' + this.audio_selecionado] ) { 
                return this.$refs['audio' + this.audio_selecionado][0];
            }

            return null; 
        },

        tem_imagens_chave: function() { 
            return _.some(this.atp.laudo.arquivos, item => item.fl_key) ? true : false;
        }
    }, 

    beforeDestroy(){
        if ( this.audio_selec ) { 
            document.removeEventListener("keydown",this.shortcuts)
        }
    },

    methods: { 
        remover_item (id_arquivo_link) { 
            let arq = _.find(this.atp.laudo.arquivos, { id_arquivo_link: id_arquivo_link });

            console.log("remover_item", id_arquivo_link, arq);

            if (arq) { 
                _.remove(this.atp.laudo.arquivos, { id_arquivo_link: id_arquivo_link });
            }
        },

        refresh_item (item) { 

            let arq = _.find(this.atp.laudo.arquivos, { id_arquivo_link: item.id_arquivo_link });

            if (arq) { 
                Object.assign(arq, item);
            }

        },

        ver_conteudo (lateral = false) {
            this.$refs.preview.abrir(this.atp.laudo.arquivos, lateral);
        },

        selec_audio(iax){
            document.removeEventListener("keydown",this.shortcuts);

            if ( this.audio_selecionado === iax) {
                this.audio_selecionado = null;
            } else {
                this.audio_selecionado = iax;
                document.addEventListener("keydown",this.shortcuts);
            }
        }, 

        shortcuts(e){

            if(!e.ctrlKey) return;

            switch(e.key){

                case " ":
                    e.preventDefault()
                    this.toggle()
                    break

                case ",":
                    this.rewind()
                    break

                case ".":
                    this.forward()
                    break

            }

        },

        toggle(){

            if ( !this.audio_selec ) 
                return;

            if(this.audio_selec.paused){

                this.audio_selec.play();
                // this.playing=true;

            }else{

                this.smartPause();

            }

        },

        smartPause(){

            if ( !this.audio_selec ) 
                return;

            this.audio_selec.pause();

            if(this.lastSilence){

                this.audio_selec.currentTime=this.lastSilence

            }

            // this.playing=false

        },

        rewind(){

            if ( !this.audio_selec ) 
                return;

            this.audio_selec.currentTime=Math.max(
                0,
                this.audio_selec.currentTime-3
            )

        },

        forward(){

            if ( !this.audio_selec ) 
                return;

            this.audio_selec.currentTime=Math.min(
                this.audio_selec.duration,
                this.audio_selec.currentTime+3
            )

        },
    }
}
</script>
